"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import { Routes, Route, Navigate } from "react-router";
export const ShellSwitch = (props) => {
  const { children, ...rest } = props;
  return /* @__PURE__ */ jsxs(Routes, { ...rest, children: [
    children,
    /* @__PURE__ */ jsx(Route, { element: /* @__PURE__ */ jsx(Navigate, { to: "/404" }) })
  ] });
};
